/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProcedureTransactionSummaryViewModel } from './procedureTransactionSummaryViewModel';

export interface VisitSummaryViewModel {
  patientId?: string;
  id?: string;
  referenceNumber?: number;
  adjusted?: number;
  balance?: number;
  paid?: number;
  daysAged?: number;
  latestProcedureTransaction?: string | null;
  procedureAmount?: number;
  lastBilledDate?: string | null;
  lastBilledInsurance?: string | null;
  patientBalance?: number;
  insuranceBalance?: number;
  claimStatus?: string | null;
  collectionsAssignDate?: string | null;
  pendingBatches?: string | null;
  isMerged?: boolean;
  delinquencyCode?: number;
  holdStatus?: string | null;
  readonly holdStatusDisplay?: string | null;
  primaryInsuranceCarrier?: string | null;
  secondaryInsuranceCarrier?: string | null;
  tertiaryInsuranceCarrier?: string | null;
  financialClass?: string | null;
  primaryInsuranceId?: string | null;
  secondaryInsuranceId?: string | null;
  tertiaryInsuranceId?: string | null;
  procedures?: Array<ProcedureTransactionSummaryViewModel> | null;
}
